<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <validation-observer ref="providerFeeDetailForm">
        <b-form ref="providerFeeDetailFormElement" class="" @submit.prevent="submit">
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Description') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="t('Description')"
                  rules="required"
                >
                  <b-form-input
                    id="description"
                    v-model="values.description"
                    name="description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Description')"
                    :tabindex="1"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="price">{{ t('Price') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Price')" rules="required">
                  <b-form-input
                    id="price"
                    v-model="values.price"
                    name="price"
                    type="number"
                    step="0.0001"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Price')"
                    :tabindex="2"
                    autocomplete="off"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="pricingType">{{ t('Pricing Type') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="t('Pricing Type')"
                  rules="required"
                >
                  <b-form-select
                    v-model="values.pricingType"
                    :options="pricingTypeOptions"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Pricing Type')"
                    :tabindex="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="status">{{ t('Status') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Status')" rules="required">
                  <b-form-select
                    v-model="values.status"
                    :options="statusOptions"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Status')"
                    :tabindex="4"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                variant="primary"
                class="mt-1 d-flex align-items-center"
                type="submit"
                :tabindex="5"
              >
                {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Save') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormSelect,
  BButton,
  BOverlay
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import { helper } from '@core/mixins/helper';

export default {
  components: {
    BOverlay,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BForm,
    BFormSelect,

    ValidationObserver,
    ValidationProvider
  },

  mixins: [togglePasswordVisibility, helper],
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          description: '',
          price: '',
          pricingType: '',
          status: ''
        };
      }
    }
  },
  data() {
    return {
      statusTypeOptions: [],
      pricingType: []
    };
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },

    pricingTypeOptions() {
      const options = [{ text: this.$t('Make a Choice'), value: '' }];
      if (this.pricingType && this.pricingType.length > 0) {
        options.push(
          ...this.pricingType.map(item => ({
            text: item.info,
            value: item.value
          }))
        );
      }
      return options;
    },
    statusOptions() {
      const options = [{ text: this.$t('Make a Choice'), value: '' }];
      if (this.statusTypeOptions && this.statusTypeOptions.length > 0) {
        options.push(
          ...this.statusTypeOptions.map(item => ({
            text: item.info,
            value: item.value
          }))
        );
      }
      return options;
    }
  },

  async created() {
    this.pricingType = await this.getProviderAdditionalFeePricingType();
    this.statusTypeOptions = await this.getProviderAdditionalFeeStatus();
  },

  methods: {
    submit() {
      this.$refs.providerFeeDetailForm.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values
          });
        }
      });
    },

    resetForm() {
      this.$refs.providerFeeDetailFormElement.reset();
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
